export default __webpack_public_path__ + "static/pete-big-arms-a3fb74bf9fe8438a762a4da976900c53.png";